document.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector('.directions-detail-popup')) {
    const directionsDetailPopup = document.getElementById('directions-detail-popup');
    const directionsDetailPopupScrollBlock = document.querySelector('.directions-detail-popup__scroll');
    const directionsDetailPopupInner = directionsDetailPopup.querySelector('.directions-detail-popup__inner');
    const directionsDetailClose = directionsDetailPopup.querySelector('.directions-detail-popup__close');
    const programDetailTriggers = document.querySelectorAll(
      '[data-program-detail-trigger="true"][data-programfulldata]'
    );


    // Закрыть при клике вне контента
    directionsDetailPopup.addEventListener('click', (e) => {
      if (!directionsDetailPopupInner.contains(e.target)) {
        directionsDetailPopupInner.classList.remove('open');
        setTimeout(() => {
            directionsDetailPopup.classList.remove('directions-detail-popup--active');
            document.body.classList.remove('no-scroll');
        }, 300);
      }
    });

    directionsDetailClose.addEventListener('click', (e) => {
      directionsDetailPopupInner.classList.remove('open');
      setTimeout(() => {
          directionsDetailPopup.classList.remove('directions-detail-popup--active');
          document.body.classList.remove('no-scroll');
      }, 300);
    });


    programDetailTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const directionData = JSON.parse(trigger.dataset.programfulldata);

        const directionTags = directionsDetailPopup.querySelectorAll('.directions-detail-info__tag');
        const directionTitle = directionsDetailPopup.querySelector('.directions-detail-info__title');
        const directionDescripriton = directionsDetailPopup.querySelector('.directions-detail-info__desc');
        const directionImage = directionsDetailPopup.querySelector('.directions-detail-info__illustration-img');
        const directionFactPeriod = directionsDetailPopup.querySelector('.directions-detail-info__fact.period-fact');
        const directionFactDuration = directionsDetailPopup.querySelector('.directions-detail-info__fact.duration-fact');
        const directionClassesFact = directionsDetailPopup.querySelector('.directions-detail-info__fact.classes-fact');
        const directionClassesList = directionsDetailPopup.querySelector('.directions-detail-info__classes-list');
        const directionTopicsSection = directionsDetailPopup.querySelector('.directions-detail-topics');
        const directionTopics = directionsDetailPopup.querySelector('.directions-detail-topics__grid');
        directionClassesList.replaceChildren();
        directionTopics.replaceChildren(); // очищаем предыдущие темы

        directionTitle.innerText = directionData.displayTitle || directionData.title;
        directionTags[0].innerText = directionData.hours;
        if(directionData.frequency){
          directionTags[1].innerText = directionData.frequency;
          directionTags[1].className = "directions-detail-info__tag " + directionData.color;
        }
        else directionTags[1].className = "directions-detail-info__tag d-none";
        directionDescripriton.innerText = directionData.descriptionFull;
        directionImage.src = directionData.image;
        directionFactPeriod.innerText = directionData.studyPeriod;
        directionFactDuration.innerText = directionData.durationTraining;
        
        const visibleTopics = Array.isArray(directionData.topicsData)
          ? directionData.topicsData
            .map((topic) => ({
              ...topic,
              titleText: String(topic.title || '').trim(),
              descriptionText: String(topic.description || '').trim(),
              colorClasses: String(topic.colors || 'bg-blue-lightest').trim(),
            }))
            .filter((topic) => topic.titleText || topic.descriptionText)
          : [];

        const classTopics = Array.from(
          new Map(
            visibleTopics
              .filter((topic) => topic.titleText)
              .map((topic) => [topic.titleText, topic])
          ).values()
        );

        classTopics.forEach((topic) => {
          const classChip = document.createElement('span');
          classChip.className = `directions-detail-info__class-chip ${topic.colorClasses}`;
          classChip.textContent = topic.titleText;
          directionClassesList.appendChild(classChip);
        });
        directionClassesFact.hidden = classTopics.length === 0;

        const detailedTopics = visibleTopics.filter((topic) => topic.descriptionText);

        if(detailedTopics.length) {
          directionTopicsSection.hidden = false;
          detailedTopics.forEach((topic) => {
            const topicTitleText = topic.titleText;
            const topicDescriptionText = topic.descriptionText;

            const topicItem = document.createElement('div');
            topicItem.className = `directions-detail-topics__card ${topic.colorClasses}`;

            if (topicTitleText) {
              const topicTitle = document.createElement('h3');
              topicTitle.textContent = topicTitleText;
              topicItem.appendChild(topicTitle);
            }

            if (topicDescriptionText) {
              const topicDescription = document.createElement('p');
              topicDescription.textContent = topicDescriptionText;
              topicItem.appendChild(topicDescription);
            }

            directionTopics.appendChild(topicItem);
          });
        } else {
          directionTopicsSection.hidden = true;
        }
        

        directionsDetailPopup.classList.add('directions-detail-popup--active');
        directionsDetailPopupScrollBlock.scrollTo(0,0)
        setTimeout(() => {
          directionsDetailPopupInner.classList.add('open');
        }, 10);
        document.body.classList.add('no-scroll'); // блокируем прокрутку фона
        
      });
    });
  }
});
